if($('html[lang="cs"]').length){
    var videoConzultation = 'domluvit si videokonzultaci';
    var videoConzultationLint = '/kontakty/';
    var ieFail = 'Internet Explorer není podporovaný prohlížeč, prosím využijte moderní alternativu, Google Chrome, atd. Děkujeme za pochopení.';
    var freeShipping = 'DOPRAVA ZDARMA';
    var nausnice = 'náušnice';
    var kamenyObchod = 'KAMENNÝ OBCHOD';
    var tipyNaVanocniDarky = 'Tipy na vánoční dárky';
    var pozdejProces = 'POZNEJTE PROCES VÝROBY';
    var darkovePoukazy = '/darkove-poukazy/';
    var tipy = 'tipy';
    var sperky = '.in-sperky-na-zakazku .content-inner article h1';
    var texts = ["Zásnubní prsten", "Snubní prsten", "zásnubní prsten", "snubní prsten"];
    var velikostPrstenu= 'VELIKOST PRSTENU';
    var linkHelpUs = '/jak-na-zasnuby/jak-zjistit-spravnou-velikost-prstenu/';
    var helpUs = '(poradíme vám)';
    var placeholderText = 'Napište velikost';
    var Certifikata4Cdiamantu = 'Certifikát a 4C diamantu';
    var certifikatUrl = '/certifikat/';
    var VyrobaDopravaAplatba = 'Výroba, doprava a platba';
    var vyrobaUrl = '/vyroba--doprava-a-platba/';
    var darkoveBaleni = 'Dárkové balení';
    var darkoveBaleniUrl = '/darkove-baleni/'
    var velikostCentralnihoKamene = 'VELIKOST CENTRÁLNÍHO KAMENE';
    var velikostCentralnihoKameneHtml = 'VELIKOST CENTRÁLNÍHO KAMENE <a>(certifikát)</a><span>U všech diamantů větších 0,30 ct poskytujeme mezinárodní certifikáty GIA, HRD, nebo IGI.</span>';
    var od = 'Od';
    var Poptat = 'Poptat';
    var detailniPopis = 'Detailní popis';
    var objednat = 'Objednat';
    var související = 'Související';
    var poslattipNaDarek = 'Poslat tip na dárek';
    var upravitNaMiru = 'Upravit na míru';
    var kamennyObchod = 'KAMENNÝ OBCHOD';
    var darkovyPoukaz = 'DÁRKOVÝ POUKAZ NA ŠPERK NA MÍRU';
    var certifikovaneDiamanty = 'CERTIFIKOVANÉ DIAMANTY';
    var skladem = 'Skladem';
    var poslatTip = 'Poslat tip na dárek'
}
if($('html[lang="en"]').length){
    var videoConzultation = 'arrange a video consultation';
    var videoConzultationLint = '/en/contact/';
    var ieFail = 'Internet Explorer is not a supported browser, please use a modern alternative, Google Chrome, etc. Thank you for your understanding.';
    var freeShipping = 'FREE SHIPPING';
    var nausnice = 'earring';
    var kamenyObchod = 'STORE';
    var tipyNaVanocniDarky = 'Christmas gift ideas';
    var pozdejProces = 'KNOW THE PRODUCTION PROCESS';
    var darkovePoukazy = '/gift-cards/';
    var tipy = 'tips';
    var sperky = '.in-custom-jewelry .content-inner article h1';
    var texts = ["Engagement ring", "GRACE wedding", "engagement ring", "Grace wedding"];
    var velikostPrstenu = 'RING SIZE';
    var linkHelpUs = '/jak-na-zasnuby/jak-zjistit-spravnou-velikost-prstenu/';
    var helpUs = '(we will advise you)';
    var placeholderText = 'Write the size';
    var Certifikata4Cdiamantu = 'Certificate and 4C of Diamond';
    var certifikatUrl = '/en/certificate/';
    var VyrobaDopravaAplatba = 'Production, shipping and payment';
    var vyrobaUrl = '/en/production-shipping-payment/';
    var darkoveBaleni = 'Gift package';
    var darkoveBaleniUrl = '/en/gift-package/'
    var velikostCentralnihoKamene = 'CENTER STONE SIZE';
    var velikostCentralnihoKameneHtml = 'CENTER STONE SIZE <a>(certificate)</a><span>For all diamonds larger than 0.30 ct, we provide international GIA, HRD, or IGI certificates.</span>';
    var od = 'From';
    var Poptat = 'Ask';
    var detailniPopis = 'Detailed description';
    var objednat = 'Order';
    var související = 'Related';
    var poslattipNaDarek = 'Send a gift tip';
    var upravitNaMiru = 'Customize';
    var kamennyObchod = 'STORE';
    var darkovyPoukaz = 'GIFT VOUCHER FOR CUSTOM JEWELRY';
    var certifikovaneDiamanty = 'CERTIFIED DIAMONDS';
    var skladem = 'In stock';
    var poslatTip = 'Send a gift tip'
}